import React, { Fragment } from "preact/compat";
import { GameInfo } from "../GameInfo/GameInfo";
import { AffLink } from "../../../💎Atoms/AffLink/AffLink";
import { Modal } from "../../Modal/Modal";
import { ModalFooter } from "../../../💎Atoms/Modal/Footer/ModalFooter";
import { ModalBody } from "../../../💎Atoms/Modal/Body/ModalBody";
import { ToggleModalProps } from "./toggleModal.type";

export const ToggleModal: React.FunctionComponent<ToggleModalProps>  = ({
    t,
    site,
    toggle,
    betData,
    addBs = false,
    onClick,
    onClose
}) => {    
    const partnerSelected = betData?.selectedBet?.sportsbook;
    toggle && Object.keys(betData).length > 0 ? document.body.classList.add("bs-open", "modal-open") : '';

    return (
      <Fragment>
        <div onClick={onClose}>
        <Modal 
            modalId="betslip-modal" 
            modalToggle={toggle && Object.keys(betData).length > 0} 
            modalStyle="modal-dialog-centered m-0 px-3 px-lg-0">
            <ModalBody className="d-flex justify-content-between align-items-start p-0" onClose={onClose}>
                {betData ?
                    <GameInfo 
                        site={site}
                        showLogo={true} 
                        gameInfo={betData.game[betData.selectedTeam]} 
                        gameData={betData} />  
                :''}
            </ModalBody>
            <ModalFooter className="border-0 d-flex flex-column mt-3 p-0">
                <button 
                    type="button" 
                    className={`btn ${site === "covers" ? "btn-secondary fs-7" : "btn-primary fs-8"} mb-2`} 
                    data-bs-dismiss="modal" 
                    onClick={onClick}
                    data-aatracker={`${site === "sbr" ? 'bet-slip-add-to-bet-slip-confirm' : ''}`}
                    data-linkcont={`${site === "covers" ? 'bet-slip-add-to-bet-slip-confirm' : ''}`} >
                    {addBs ? t.modal.betslip_cta_disabled : t.modal.betslip_cta}
                </button>
                {partnerSelected ? 
                <AffLink 
                    className={`ms-0 ${site === "covers" ? "fs-7" : "fs-8"}`}
                    site={site}
                    url={partnerSelected.sportsbookClickout}
                    aalink={`bet-slip-to-sportsbook-confirm`}
                    type="outline-secondary">
                        {t.footer.cta}&nbsp;{partnerSelected.sportsbookName}
                    </AffLink>
                : ''}
            </ModalFooter>
        </Modal>
        </div>
      </Fragment>
    )
}